import { createAsyncThunk } from '@reduxjs/toolkit';
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

export const getAboutUsInfo = createAsyncThunk(
  'fetch/about',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        URLS.ABOUT_US.GET_ABOUT_US_CONTENT
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
